export default __webpack_public_path__ + "static/media/loops.320813c9.PNG";